import type { Lesson, LessonOverride, Term } from '@court-sync/shared';
import { getNextAvailableDropInSessionDate } from '@court-sync/shared';

/** Resolve the next drop-in session date for a group term lesson. */
export function resolveGroupDropInSessionDate(
  lesson: Lesson,
  term: Term | null,
  excludedDates: string[] = [],
  overrides: LessonOverride[] = []
): string | null {
  if (lesson.lessonType !== 'group' || lesson.sessionPrice == null) return null;
  return getNextAvailableDropInSessionDate(lesson, term, excludedDates, overrides);
}
